import { z } from 'zod';
import { LEAFLINK_ENVIRONMENTS } from './environment/leaflink-environments.js';
export const createLeafLinkCompanyInputSchema = z.object({
    environment: z.enum(LEAFLINK_ENVIRONMENTS, { message: 'A valid environment is required.' }),
    apiKey: z.string().trim().min(1, 'API key is required.').max(512, 'API key is too long.'),
});
//# sourceMappingURL=create-leaflink-company-input-schema.js.map